import angular from 'angular';

/**
 *
 */
class CommonClass {
    /**
     *
     */
    constructor() {
        this.module = angular.module('nuskin-mec-common', []);
    }
}

export var CommonApp = new CommonClass();
export default CommonApp;




//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/app.js
// module id = 1
// module chunks = 0